// extracted by mini-css-extract-plugin
export default {"choice":"eUAQBSpJ3byWF3Wk109d"};